var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=ts&"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=0675f8a5&scoped=true&lang=css&"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675f8a5",
  null
  
)

export default component.exports